'use strict';

var FlowMixChartDataProviderService = function FlowMixChartDataProviderService(SearchCriteriaRule, dataRetrieverService, constants, serviceFilterBuilderService, flightSearchCriteriaFilterBuilderService, userPreferencesService, $q, representationService) {
  function transformData(dataRepresentation, metric) {
    return function (data) {
      var threshold = userPreferencesService.getUserSettingComponent('topFlowMarketThreshold');
      if (data === undefined) {
        return undefined;
      }
      if (data.length > threshold) {
        data = data.slice(0, threshold);
      }
      return data.map(function (item) {
        item.stackLabel = item.label;
        return metric === 'loadFactor' ? representationService.prepareLFChartBarMetricsInAbsolute(item, dataRepresentation) : representationService.prepareChartBarMetrics(item, dataRepresentation);
      });
    };
  }
  function getServiceData(metric, associatedServiceClasses) {
    if (!Array.isArray(associatedServiceClasses) || associatedServiceClasses.length === 0) {
      //no need to make request to the server, result will be empty anyway;
      return $q.resolve([]);
    }
    var serviceDataRetriever = dataRetrieverService.getDataRetriever(constants.FLIGHT_SCREEN, constants.SERVICE_MODE);
    var filter = serviceFilterBuilderService.buildFilter(associatedServiceClasses);
    return serviceDataRetriever.updateMetricValues(metric).retrieveData('market-mix-graph', filter);
  }
  function getData(metric, dataRepresentation) {
    var cabinDataRetriever = dataRetrieverService.getDataRetriever(constants.FLIGHT_SCREEN, constants.CABIN_DEEP_MODE);
    var rules = flightSearchCriteriaFilterBuilderService.buildFilter();
    return cabinDataRetriever.setCustomSearchCriteriaRules(rules).localSortApplied().retrieveComponentData('service-flight-analysis').then(getServiceData.bind(null, metric)).then(transformData(dataRepresentation, metric));
  }
  return {
    getData: getData
  };
};
FlowMixChartDataProviderService.$inject = ['SearchCriteriaRuleFactory', 'DataRetrieverService', 'DataRetrieverConstantsService', 'ServiceFilterBuilderService', 'FlightSearchCriteriaFilterBuilderService', 'UserPreferencesService', '$q', 'DataRepresentationService'];
module.exports = FlowMixChartDataProviderService;